import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Callout } from "@radix-ui/themes";

const CartIsEmpty = () => {
  return (
    <Callout.Root variant="soft" size="1">
      <Callout.Icon>
        <InfoCircledIcon />
      </Callout.Icon>
      <Callout.Text>Cart is empty</Callout.Text>
    </Callout.Root>
  );
};

export default CartIsEmpty;
